import { TileState } from "../../../pillar/dashboard/store/state/TileState";
import { RuleListModel } from "../../models/RuleListModel";
import { RuleModel } from "../../models/RuleModel";

export class RuleState extends TileState<RuleListModel, RuleModel> {
  public isEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/state/RuleState.ts